var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fd-ondemand"},[_c(_vm.FastLoading,{tag:"component"}),_c(_vm.HomeHeader,{tag:"component",attrs:{"pagina-atual":_vm.paginaAtual}}),_c(_vm.LojaVirtualContent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }